import React, { useState, useContext, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import CustomerDocsContext from '../../services/customerDocsService'
import MarkdownRenderer from '../../Components/MarkdownRenderer'

const baseRoute = '/customerDocs'

const CustomerDocs = () => {
  const { '*': path } = useParams()
  const [text, setText] = useState('')
  const api = useContext(CustomerDocsContext)

  useEffect(() => {
    const getDocs = async () => {
      const finalPath = path || 'README.md'
      const result = await api.getDocumentation(finalPath)
      setText(result)
    }
    getDocs()
  }, [path, api])

  return (
    <>
      <MarkdownRenderer markdownText={text} baseRoute={baseRoute} />
    </>
  )
}

export default CustomerDocs
